export default {
  getCorporationByName: (state) => (inputValue) => {
    return state.corporations.filter(corporation => {
      var companyNameResult = null
      var corporationName = null
      if (corporation.companyName !== null) {
        companyNameResult = corporation.companyName.match(inputValue)
      }
      if (corporation.corporationName !== null) {
        corporationName = corporation.corporationName.match(inputValue)
      }
      if (companyNameResult !== null || corporationName !== null) {
        var result = corporation.companyName + corporation.corporationName
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/companiesModules/getters.js